export const getTotalCosts = (charges: Array<{ TotalCost: number }>) => {
  return charges?.reduce((total, next) => {
    return total + next.TotalCost;
  }, 0);
};

export const formatTel = (stringToFormat: string, phoneCode = '1') => {
  if (!stringToFormat) {
    return 'None';
  }

  const cleaned = String(stringToFormat || '').replace(/\+1|\D/g, '');
  const match = (/^(\d{3})(\d{3})(\d{4})$/).exec(cleaned);
  if (match) {
    const code = phoneCode ? `+${phoneCode}`: ''
    return code + ' (' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return stringToFormat;
};

